"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const painPoints = [{
  title: "Valve Dysfunction",
  description: "When the tiny valves in your veins fail to close properly, blood pools in the lower limbs instead of flowing back to the heart efficiently."
}, {
  title: "Venous Pressure",
  description: "Persistent high pressure within the leg veins leads to stretching of the vessel walls and subsequent swelling or deep tissue discomfort."
}, {
  title: "Fluid Retention",
  description: "Fluid accumulation, or edema, often appears by the end of the day, indicating that the lymphatic and venous systems are struggling."
}, {
  title: "Skin Changes",
  description: "Chronic inflammation can cause the skin around the ankles to become discolored, thickened, or prone to persistent irritation and ulcers."
}, {
  title: "Muscle Fatigue",
  description: "A characteristic feeling of heaviness or weight in the legs that typically worsens after long periods of standing or sedentary behavior."
}, {
  title: "Progression Risks",
  description: "If left untreated, simple spider veins can progress into painful varicose veins or more serious conditions like deep vein thrombosis."
}];
export default function TheReality() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="150691" id="what-is-condition" ref={sectionRef} className="bg-[#F8F8F6] py-24 md:py-32 overflow-hidden relative border-y border-[#E2E8F0]">
      {}
      <div className="absolute inset-0 bg-gradient-to-br from-black/5 to-transparent pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          
          {}
          <div className={`lg:col-span-5 flex flex-col justify-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <span className="font-mono text-accent tracking-[0.1em] uppercase mb-6 block text-sm font-semibold">
              Medical Overview
            </span>
            <h2 className="font-serif text-foreground text-4xl md:text-[3rem] leading-[1.1] font-bold mb-6">
              What is Chronic Venous Insufficiency?
            </h2>
            <p className="font-sans text-muted-foreground text-lg leading-[1.6] tracking-[-0.01em] max-w-md">
              Understanding the underlying causes and symptoms of venous conditions is the first step toward effective treatment and long-term recovery.
            </p>
          </div>

          {}
          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {painPoints.map((point, i) => <div key={i} data-index={i} className={`transition-all duration-700 ease-out delay-${i * 100}`} style={{
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? "translateY(0)" : "translateY(20px)",
              transitionDelay: `${i * 100}ms`
            }}>
                  <Card className="h-full bg-card backdrop-blur-none border-[1px] border-border rounded-xl transition-all duration-200 hover:-translate-y-1 hover:shadow-md hover:border-accent/20 hover:bg-card !gap-4 !py-6">
                    <CardHeader className="pb-0 px-6">
                      <CardTitle className="font-serif text-foreground text-xl md:text-[1.5rem] font-bold leading-tight">
                        {point.title}
                      </CardTitle>
                    </CardHeader>
                    <CardContent className="px-6 pt-2">
                      <p className="font-sans text-muted-foreground text-[16px] leading-[1.6] tracking-[-0.01em]">
                        {point.description}
                      </p>
                    </CardContent>
                  </Card>
                </div>)}
            </div>
          </div>

        </div>
      </div>
    </section>;
}